// extracted by mini-css-extract-plugin
export var readonly = "_hf-1";
export var star = "_hf-0";